import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { updateEntityFont, updateFontFamily } from 'actions/livefeed'

import { googleFonts } from './googleFonts'
import Select from 'react-select';

const FontFamilyDropdown = (props) => {
    const { slideCurrentIndex, livefeedSlides, dispatch, editorView } = props
    const { fontFamily } = livefeedSlides.slice()[slideCurrentIndex]
    const fontsList = [];
    googleFonts.map(value => {
        return fontsList.push({ values: value, label: value });
    })
    const handleSelect = useCallback((font) => {
        // currentFont
        let entityFont = {
            slideCurrentIndex: slideCurrentIndex,
            id: null,
            fontFamily: fontFamily
        }

        dispatch(updateEntityFont(entityFont)) // use this for history matter
        dispatch(updateFontFamily(font))
    }, [dispatch, fontFamily, slideCurrentIndex])

    return (
        <div data-tooltip="Font Family" className={`reactSelect-dropdown-wrapper ${editorView ? '' : 'font-family-dropdown-wrapper_disable'}`} >
            <Select
                className="reactSelect-fontFamily-dropdown"
                options={fontsList}
                onChange={(font) => { handleSelect(font.values) }}
                placeholder={fontFamily}
                value={fontFamily}
                openOnClick={true}
            />
        </div>

    );
}
FontFamilyDropdown.propTypes = {
    dispatch: PropTypes.func.isRequired,
    livefeedSlides: PropTypes.array.isRequired, // array with 1 object is considered to be a template.
    editorView: PropTypes.bool.isRequired,
    slideCurrentIndex: PropTypes.number.isRequired
}
export default FontFamilyDropdown;



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/ToolbarContainer/ToolbarOptions/FontFamilyDropdown/index.jsx